exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".detail-dialog[data-v-156ac90b]  .el-loading-mask{background:rgba(26,68,71,.6784313725)!important}", ""]);

// exports
